module.exports = "https://cdn.hellotech.com/client-assets/security_cameras_desktop_0a97bc8ad72b07599eafe6fa07bb68e6.webp";